import axios from "axios";
import { getUserToken } from "../helpers/local_storage_helpers";
import { userExpanseAnalyticsApi, userExpanseDetailApi } from "../constants/apis";

export const getExpenseDetails = async (expenseId) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    try {
        const response = await axios.get(
            `${userExpanseDetailApi}${expenseId}`,
            config
        );
        return response;
    } catch (error) {
        console.error("Error fetching expense details:", error);
        throw error;
    }
};

export const getExpenseAnalytics = async (expenseId) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    try {
        // Replace with actual analytics API endpoint
        const response = await axios.get(
            `${userExpanseAnalyticsApi}${expenseId}`,
            config
        );
        return response;
    } catch (error) {
        console.error("Error fetching expense analytics:", error);
        throw error;
    }
};
